
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/reservar-viajes",
      function () {
        return require("private-next-pages/[region]/[resort]/reservar-viajes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/reservar-viajes"])
      });
    }
  